import { sendWebsocketMessage } from '../../../../../App';
import { getMarketDataRoute } from '../../marketDataRouting';
/**
 * Request an option chain from the backend
 * @param {number} id of the message. This needs to be a unique key. We will send back the request with this key.
 * This is how you sort which incoming message goes to which component.
 * @param {string[]} expirationDates array of expiration dates that you would like options for
 * @param {string} symbol underlying symbol
 * @param {string} dataSource live or sim data
 */
export function requestOptionChains(
  id,
  expirationDates,
  symbol,
  dataSource,
  brokerage,
  accountNumber
) {
  if (!Array.isArray(expirationDates) || expirationDates.length === 0) {
    return;
  }

  const route = getMarketDataRoute({
    dataSource,
    brokerage,
    messageType: 'requestOptionChains',
    symbol,
  });
  if (!route.valid) {
    return;
  }
  const msg = {
    messageType: 'requestOptionChains',
    id,
    expirationDates,
    symbol,
    dataSource,
    brokerage: route.brokerage,
  };
  if (accountNumber) {
    msg.accountNumber = accountNumber;
  }
  sendWebsocketMessage(msg);
}
